import React from 'react';
import {
	CSSZSickLeaveCertificate,
	CSSZUser,
} from '../../Interfaces/CSSZ.interface';
import styles from './CSSZSickLeaveCertificateDetail.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import CSSZSickLeaveCertificateDetailItem from './CSSZSickLeaveCertificateDetailItem';
import CSSZSickLeaveCertificateDetailControls from './CSSZSickLeaveCertificateDetailControls';
import { formatCSSZSystemAddress } from '../../Helpers/CSSZ.helper';
import CSSZSickLeaveCertificateDetailSubmissions from './CSSZSickLeaveCertificateDetailSubmissions';
import { Document } from '../../../../graphql/graphql';
import CSSZSickLeaveMoneyTicketDetailItem from './CSSZSickLeaveMoneyTicketDetailItem';

interface Props {
	item: CSSZSickLeaveCertificate;
	user: CSSZUser;
	onJobSuccess?: () => void;
}

const CSSZSickLeaveCertificateDetail: React.FC<Props> = ({
	item,
	user,
	onJobSuccess,
}) => {
	return (
		<div className={styles.wrapper}>
			<CSSZSickLeaveCertificateDetailControls
				item={item}
				user={user}
				onJobSuccess={onJobSuccess}
			/>
			<div className={styles.content}>
				<Text
					tx='component.CSSZSickLeaveCertificateDetail.title'
					className={styles.title}
				/>
				<div className={styles.items}>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.evidenceNumber'
						value={item.data.decisionNumber}
						bold
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='IČPE'
						value={item.data.icpe}
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.incapacityStartDate'
						value={item.data.sickLeave.dateFrom}
						formatDate
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.diagnosis'
						value={item.data.sickLeave.diagnosis}
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.createdAt'
						value={item.createdAt}
						formatDate
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.addressOfResidence'
						value={formatCSSZSystemAddress(item.data.patientAddress)}
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.nameAndAddressOfEmployer'
						value={`${item.data.employment.employer}, ${formatCSSZSystemAddress(
							item.data.employment.address,
						)}`}
					/>
					<CSSZSickLeaveCertificateDetailItem
						title='component.CSSZSickLeaveCertificateDetail.profesion'
						value={item.data.employment.profession}
					/>
					{item.moneyTicket && (
						<CSSZSickLeaveMoneyTicketDetailItem item={item.moneyTicket} />
					)}
				</div>
				<CSSZSickLeaveCertificateDetailSubmissions
					submissions={item.submissions}
				/>
			</div>
		</div>
	);
};

export default CSSZSickLeaveCertificateDetail;
